
import React from 'react';
import {isAppWebView} from 'utils/appWebview';

import {Facebook} from './_Facebook';
import {HubSpot} from './_HubSpot';
import {Impact} from './_Impact';
import {TikTok} from './_TikTok';
import {Twitter} from './_Twitter';

export const Scripts = () => {
	// Apple treats a WebView used for app functionality as app code, so these
	// would count as the app tracking users. Returning before the children
	// exist keeps their <Script> effects from ever running. GTM is emitted
	// into the static HTML by gatsby-config, so it's gated in the container.
	if (isAppWebView()) {
		return null;
	}

	return (
		<>
			<HubSpot />
			<Facebook />
			<Impact />
			<TikTok />
			<Twitter />
		</>
	);
};
